// Minimal shared side-panel host + collapsed rail, extracted from Capacity's
// Scenario composition (main card, then panel or rail on the right). Capacity
// renders one rail button; Projects Updates renders Team / Media / collapse.
import { T } from "../app/tokens.js";

export const RAIL_BUTTON_STYLE = { flex: "0 0 36px", width: 36, minHeight: 160, display: "flex", flexDirection: "column", alignItems: "center", gap: 12, padding: "12px 0", border: `1px solid ${T.border}`, borderRadius: 8, background: T.card, color: T.mid, fontFamily: "inherit", cursor: "pointer" };

export function SidePanelHost({ children, gap = 10, testId, className, style }) {
  return <div data-testid={testId} className={className} style={{ display: "flex", alignItems: "flex-start", gap, minWidth: 0, ...style }}>{children}</div>;
}

/** Single collapsed rail button (Capacity Scenario). */
export function SidePanelRailButton({ icon, label, onClick, testId, ariaLabel, expanded = false, style }) {
  return (
    <button type="button" data-testid={testId} aria-label={ariaLabel} aria-expanded={expanded} onClick={onClick} style={{ ...RAIL_BUTTON_STYLE, ...style }}>
      {icon}<span style={{ writingMode: "vertical-rl", fontSize: T.fsSm, fontWeight: T.fwBold }}>{label}</span>
    </button>
  );
}

/** Multi-item rail: items [{key,label,icon}], active key or null, plus optional collapse. */
export function SidePanelRail({ items, active, onSelect, onCollapse, testId = "side-panel-rail", ariaLabel = "Side panel" }) {
  return (
    <nav aria-label={ariaLabel} data-testid={testId} style={{ flex: "0 0 44px", width: 44, boxSizing: "border-box", background: T.card, border: `1px solid ${T.border}`, borderRadius: 12, display: "flex", flexDirection: "column", alignItems: "center", padding: "8px 0", gap: 6 }}>
      {items.map((item) => {
        const on = active === item.key;
        return (
          <button key={item.key} type="button" data-testid={`${testId}-${item.key}`} aria-pressed={on} aria-label={item.ariaLabel || item.label} onClick={() => onSelect(item.key)}
            style={{ width: 34, padding: "10px 0", borderRadius: 8, border: 0, display: "flex", flexDirection: "column", alignItems: "center", gap: 6, cursor: "pointer", fontFamily: "inherit", fontSize: T.fsXxs, fontWeight: T.fwSemibold, background: on ? T.blueSoft : "transparent", color: on ? T.blue : T.mid }}>
            {item.icon}
            <span style={{ writingMode: "vertical-rl", transform: "rotate(180deg)", letterSpacing: ".04em" }}>{item.label}</span>
          </button>
        );
      })}
      {onCollapse && (
        <button type="button" data-testid={`${testId}-collapse`} aria-label={active ? "Collapse panel" : "Panel collapsed"} disabled={!active} onClick={onCollapse}
          style={{ width: 34, padding: "10px 0", borderRadius: 8, border: 0, background: "transparent", color: active ? T.mid : T.light, cursor: active ? "pointer" : "default", fontSize: T.fsMd, fontFamily: "inherit" }}>›</button>
      )}
    </nav>
  );
}
